import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, useNavigate } from "react-router-dom";
import logo from "../images/TD AI Logo 2 Color Clear.png";
import AppHeader from "../components/appHeader";
import { RemoveAlert } from "../actions/AlertActions";
import { GetUser } from "../actions/UserActions";
import { GetSettingsForUser } from "../actions/UserSettingActions";
import { LoginViaMSOAuth } from "../actions/LoginActions";
import { GetSystemSettings } from "../actions/SystemSettingsActions";
import { logout } from "../state/loginInfoSlice";
import SiteMenu from "./SiteMenu";
import WebUploadView from "./Regular/WebUpload";
import TemplateEditor from "./Regular/TemplateEditor/TemplateEditor";
import TemplateManager from "./Regular/TemplateEditor/TemplateManager";
import DefaultManager from "./Admin/Intake/Defaults/DefaultManager";
import ActiveDocuments from "./Regular/ActiveDocuments/ActiveDocuments";
import BetaActiveDocuments from "./Regular/ActiveDocuments/BetaActiveDocuments";
import DocumentEditor from "./Regular/Document/DocumentEditor";
import Search from "./Regular/Search/Search";
import SysPanel from "./Admin/SysPanel";
import ImageReviewHome from "./Regular/ImageReview/ImageReviewHome";
import ImageReviewEdit from "./Regular/ImageReview/ImageReviewEdit";
import UserProfileView from "./Regular/UserProfile/UserProfileView";
import Inbox from "./Regular/Inbox/Inbox";
import Filters from "./Regular/Inbox/Filters";
import FiltersHome from "./Regular/Inbox/FiltersHome";
import ADOAuthSettingsView from "../Views/Admin/Users/ADOAuthSettings";
import Users from "../Views/Admin/Users/Users";
import UsersView from "../Views/Admin/Users/UsersView";
import Roles from "../Views/Admin/Users/Roles";
import RolesView from "../Views/Admin/Users/RolesView";
import BusinessProcessHome from "./Admin/Business Process/BusinessProcess/BusinessProcess";
import BusinessProcessView from "./Admin/Business Process/BusinessProcess/BusinessProcessView";
import OrgUnitHome from "./Admin/Business Process/OrgUnits/OrgUnit";
import OrgUnitView from "./Admin/Business Process/OrgUnits/OrgUnitView";
import WorkflowsHome from "./Admin/Business Process/Workflows/Workflows";
import WorkflowView from "./Admin/Business Process/Workflows/WorkflowView2";
import FormTypeView from "./Admin/Business Process/FormTypes/FormTypeView";
import FormTypesHome from "./Admin/Business Process/FormTypes/FormTypes";
import ModuleHome from "./Admin/Integration/Modules/ModuleHome";
import ModuleView from "./Admin/Integration/Modules/ModuleView";
import ScheduleHome from "./Admin/Integration/Schedules/ScheduleHome";
import ScheduleView from "./Admin/Integration/Schedules/ScheduleView";
import Directories from "./Admin/Intake/DirectoryUpload/Directories";
import DirectoryView from "./Admin/Intake/DirectoryUpload/DirectoryView";
import UploadTrackerView from "../Views/Admin/UploadTracker/UploadTrackerView";
import IntakeStrategyHome from "./Admin/Intake/IntakeStrategies/IntakeStrategy";
import IntakeStrategyNew from "./Admin/Intake/IntakeStrategies/IntakeStrategyNew";
import IntakeStrategyView from "./Admin/Intake/IntakeStrategies/IntakeStrategyView";
import IntakeSettings from "./Admin/Intake/IntakeSettings/IntakeSettings";
import InboundAutomationHome from "./Admin/Intake/InboundAutomation/InboundAutomationHome";
import InboundAutomationView from "./Admin/Intake/InboundAutomation/InboundAutomationView";
import InboundAutomationNew from "./Admin/Intake/InboundAutomation/InboundAutomationNew";
import AutoOcrDocumentTypeView from "./Admin/Intake/AutoOCR/AutoOcrDocumentTypeView";
import AutoOcrMappingView from "./Admin/Intake/AutoOCR/AutoOcrMappingView";
import AutoOcrHome from "./Admin/Intake/AutoOCR/AutoOcrHome";
import DocumentUploadHistoryView from "./Regular/DocumentUploadHistory/DocumentUploadHistoryView";
import ReadersHome from "./Admin/Intake/Readers/Readers";
import ReaderView from "./Admin/Intake/Readers/ReaderView";
import ReaderMapping from "./Admin/Intake/Readers/ReaderMapping";
import DefaultHome from "./Admin/Intake/Defaults/Defaults";
import DefaultView from "./Admin/Intake/Defaults/DefaultView";
import ArchiveHome from "./Admin/Config/Archive/ArchiveHome";
import ArchiveView from "./Admin/Config/Archive/ArchiveView";
import LicenseView from "../Views/Admin/License/License";
import LicenceAllocation from "../Views/Admin/License/LicenseAllocation";
import LogView from "../Views/Regular/Logging/LogsView";
import SecretHome from "./Admin/Config/Secret/SecretHome";
import SecretView from "./Admin/Config/Secret/SecretView";
import MailboxHome from "./Admin/Config/Mailboxes/MailboxHome";
import MailboxView from "./Admin/Config/Mailboxes/MailboxView";
import ConnectionHome from "./Admin/Config/Connection/ConnectionHome";
import ConnectionView from "./Admin/Config/Connection/ConnectionView";
import Companion from "./Admin/CompanionTables/Companion";
import CompanionPage from "./Admin/CompanionTables/Companion2";
import CompanionView from "./Admin/CompanionTables/CompanionView";
import SystemSettings from "./Admin/SystemSettings/SystemSettings";
import DocAction from "./Regular/DocAction";
import TableEditor from "./Admin/TableEditor/TableEditor";
import TableEditorView from "./Admin/TableEditor/TableEditorView";
import AlertStore from "../stores/AlertStore";
import SystemAuditLogsView from "./Admin/SystemAudit/SystemAuditLogs";
import CredentialHome from "./Admin/Config/Credential/CredentialHome";
import CredentialView from "./Admin/Config/Credential/CredentialView";
import AICapture from "./Admin/AICapture/AICapture";
const AppRoot = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo.value);
  const loginInfo = useSelector((state) => state.loginInfo.value);
  const systemSettingsInfo = useSelector((state) => state.systemSettingsInfo.value);
  const [showSiteMenu, updateshowSiteMenu] = useState(false);
  const [userName, updateUserName] = useState("");
  const [canImageReview, updateCanImageReview] = useState(false);
  const [alerts, updateAlerts] = useState([]);
  const [showAboutTrinDocs, updateShowAboutTrinDocs] = useState(false);
  const [showAboutTrinForms, updateShowAboutTrinForms] = useState(false);
  const [defaultHome, updateDefaultHome] = useState("");
  const [trinFormsUrl, updateTrinFormsUrl] = useState("");
  const [betaActiveDocumentsSetting, updateBetaActiveDocumentsSetting] = useState("false");
  const navigate = useNavigate();
  const updateUserInfo = useCallback((user) => {
    if (user !== void 0 && user.userName !== void 0) {
      updateUserName(user.userName);
      updateCanImageReview(loginInfo.permissions.canImageReview);
      updateDefaultHome(user.defaultHome);
    }
  }, [loginInfo.permissions.canImageReview]);
  useEffect(() => {
    if (window.location.search.startsWith("?auth=")) {
      let auth = window.location.search.split("=")[1];
      console.log("LoginViaMSOauth");
      LoginViaMSOAuth(auth);
    }
    if (loginInfo.loggedIn === false) {
      navigate("/");
      console.log("loggedOut2");
    } else if (userInfo.loaded === false) {
      GetUser(loginInfo.userId, dispatch);
      GetSettingsForUser(loginInfo.userId, dispatch);
    } else if (userName === "") {
      updateUserInfo(userInfo.user);
    }
    if (userInfo.loaded) {
      if (userInfo.userSettings !== void 0 && userInfo.userSettings !== null) {
        if (userInfo.userSettings.betaActiveDocuments != void 0) {
          updateBetaActiveDocumentsSetting(userInfo.userSettings.betaActiveDocuments);
        } else {
          updateBetaActiveDocumentsSetting("false");
        }
      } else {
        GetSettingsForUser(loginInfo.userId, dispatch);
      }
    }
    if (loginInfo.loggedIn) {
      const hasReloaded = sessionStorage.getItem("hasReloaded") === "true";
      let appVersion = import.meta.env.VITE_VERSION;
      if (loginInfo.tdVersion !== appVersion && appVersion !== "6.1.0.DEV" && loginInfo.tdVersion !== "REACT_APP_VERSION") {
        console.log("Detected version mismatch. Backend:", loginInfo.tdVersion, "Frontend:", appVersion);
        if (!hasReloaded) {
          console.log("It appears that TrinDocs has been updated and your browser does not have the latest version.  Please hit Control-F5 or Control-Shift-R to update your local browser.");
          sessionStorage.setItem("hasReloaded", "true");
          window.location.replace(window.location.pathname);
        } else {
          alert("It appears that TrinDocs has been updated and your browser does not have the latest version.  Please hit Control-F5 or Control-Shift-R to update your local browser.");
        }
      } else {
        sessionStorage.removeItem("hasReloaded");
      }
    }
    if (!systemSettingsInfo.loaded) {
      GetSystemSettings(dispatch);
    } else {
      updateTrinFormsUrl(systemSettingsInfo.trinFormsUrl);
    }
    if (userInfo !== void 0 && userInfo.userSettings !== void 0) {
      updateDefaultHome(userInfo.userSettings.defaultHome);
    }
  }, [userInfo, loginInfo, navigate, userName, dispatch, updateUserInfo, systemSettingsInfo]);
  useEffect(() => {
    AlertStore.addChangeListener(onAlertUpdate);
    return () => {
      AlertStore.removeChangeListener(onAlertUpdate);
    };
  }, []);
  const onAlertRemove = (id) => {
    RemoveAlert(id);
  };
  const onAlertUpdate = () => {
    let currentAlerts = AlertStore.getAlerts();
    updateAlerts([...currentAlerts]);
  };
  const logOutTD = () => {
    dispatch(logout());
  };
  const onBodyClick = () => {
    updateshowSiteMenu(false);
  };
  const toggleSiteMenu = () => {
    updateshowSiteMenu(!showSiteMenu);
  };
  function getCookie(name) {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const [key, value] = cookie.trim().split("=");
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }
  function getCookie(name) {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const [key, value] = cookie.trim().split("=");
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }
  const routeToTrinForms = (e) => {
    console.log("GO TO TF");
    if (trinFormsUrl !== "") {
      try {
        let token = getCookie("td6Token");
        if (token === null) {
          token = window.localStorage.getItem("td6Token");
        }
        const enCodedtoken = encodeURIComponent(token);
        const redirectUrl = `${trinFormsUrl}/api/Auth/TrinDocsLogin?token=${enCodedtoken}`;
        const link = document.getElementById("trinFormsLink");
        if (link) {
          if (e.ctrlKey) {
            window.open(redirectUrl);
          } else {
            link.setAttribute("href", redirectUrl);
            link.click();
          }
        }
      } catch (err) {
        console.error("Error during TrinForms redirection:", err);
      }
    } else {
      updateShowAboutTrinForms(true);
    }
  };
  const toggleShowAboutTrinDocs = () => {
    updateShowAboutTrinDocs(!showAboutTrinDocs);
  };
  const toggleShowAboutTrinForms = () => {
    updateShowAboutTrinForms(!showAboutTrinForms);
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "AppRoot h-100 d-flex flex-column",
      style: { overflowX: "hidden", overflowY: "auto" }
    },
    /* @__PURE__ */ React.createElement(
      AppHeader,
      {
        user: "admin",
        onToggle: toggleSiteMenu,
        toggleAboutTrinDocs: toggleShowAboutTrinDocs
      }
    ),
    /* @__PURE__ */ React.createElement("div", { className: "flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "d-flex flex-row h-100" }, showSiteMenu && /* @__PURE__ */ React.createElement("div", { className: "tdSideNavbar coolScroll" }, /* @__PURE__ */ React.createElement(
      SiteMenu,
      {
        licenseLevel: loginInfo.trinDocsLicenseLevel,
        canImageReview,
        trinFormsUrl,
        onToggle: toggleSiteMenu,
        onRouteToTrinForms: routeToTrinForms
      }
    )), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill d-flex flex-row",
        onClick: onBodyClick
      },
      /* @__PURE__ */ React.createElement(Routes, null, defaultHome !== "Active Documents" && /* @__PURE__ */ React.createElement(Route, { path: "/", element: /* @__PURE__ */ React.createElement(Inbox, null) }), defaultHome === "Active Documents" && betaActiveDocumentsSetting.toLowerCase() === "true" && /* @__PURE__ */ React.createElement(Route, { path: "/", element: /* @__PURE__ */ React.createElement(BetaActiveDocuments, null) }), defaultHome === "Active Documents" && betaActiveDocumentsSetting.toLowerCase() !== "true" && /* @__PURE__ */ React.createElement(Route, { path: "/", element: /* @__PURE__ */ React.createElement(ActiveDocuments, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Inbox", element: /* @__PURE__ */ React.createElement(Inbox, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Filters", element: /* @__PURE__ */ React.createElement(FiltersHome, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Filters/:id", element: /* @__PURE__ */ React.createElement(Filters, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/ActiveDocuments", element: /* @__PURE__ */ React.createElement(ActiveDocuments, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/BetaActiveDocuments", element: /* @__PURE__ */ React.createElement(BetaActiveDocuments, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Search", element: /* @__PURE__ */ React.createElement(Search, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Document/:id", element: /* @__PURE__ */ React.createElement(DocumentEditor, { userId: loginInfo.userId }) }), /* @__PURE__ */ React.createElement(Route, { path: "/DocAction", element: /* @__PURE__ */ React.createElement(DocAction, null) }), canImageReview && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Route, { path: "/ImageReview", element: /* @__PURE__ */ React.createElement(ImageReviewHome, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/ImageReviewEdit",
          element: /* @__PURE__ */ React.createElement(ImageReviewEdit, null)
        }
      )), /* @__PURE__ */ React.createElement(Route, { path: "/WebUpload", element: /* @__PURE__ */ React.createElement(WebUploadView, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/UserProfile", element: /* @__PURE__ */ React.createElement(UserProfileView, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/DocUploadHist",
          element: /* @__PURE__ */ React.createElement(DocumentUploadHistoryView, null)
        }
      ), loginInfo.trinDocsLicenseLevel >= 3 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Route, { path: "/TemplateEditor", element: /* @__PURE__ */ React.createElement(TemplateManager, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/TemplateEditor/:id",
          element: /* @__PURE__ */ React.createElement(TemplateEditor, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/TemplateEditor/:id/:id2",
          element: /* @__PURE__ */ React.createElement(TemplateEditor, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Defaults",
          element: /* @__PURE__ */ React.createElement(DefaultManager, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Defaults/:id",
          element: /* @__PURE__ */ React.createElement(DefaultView, null)
        }
      )), loginInfo.trinDocsLicenseLevel >= 4 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Route, { path: "/SysPanel", element: /* @__PURE__ */ React.createElement(SysPanel, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/OrgUnits", element: /* @__PURE__ */ React.createElement(OrgUnitHome, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/OrgUnit/:id",
          element: /* @__PURE__ */ React.createElement(OrgUnitView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Logs", element: /* @__PURE__ */ React.createElement(LogView, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/BusinessProcess",
          element: /* @__PURE__ */ React.createElement(BusinessProcessHome, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/BusinessProcess/:id",
          element: /* @__PURE__ */ React.createElement(BusinessProcessView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Workflows",
          element: /* @__PURE__ */ React.createElement(WorkflowsHome, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/WorkflowView/:id",
          element: /* @__PURE__ */ React.createElement(WorkflowView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/FormType/:id",
          element: /* @__PURE__ */ React.createElement(FormTypeView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/FormTypes",
          element: /* @__PURE__ */ React.createElement(FormTypesHome, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Modules", element: /* @__PURE__ */ React.createElement(ModuleHome, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Module/:id", element: /* @__PURE__ */ React.createElement(ModuleView, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Schedules", element: /* @__PURE__ */ React.createElement(ScheduleHome, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Schedule/:id",
          element: /* @__PURE__ */ React.createElement(ScheduleView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Users", element: /* @__PURE__ */ React.createElement(Users, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/UsersView/:id",
          element: /* @__PURE__ */ React.createElement(UsersView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Roles", element: /* @__PURE__ */ React.createElement(Roles, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/RolesView/:id",
          element: /* @__PURE__ */ React.createElement(RolesView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/LicenseAllocation",
          element: /* @__PURE__ */ React.createElement(LicenceAllocation, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/LoginSettings",
          element: /* @__PURE__ */ React.createElement(ADOAuthSettingsView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Directories",
          element: /* @__PURE__ */ React.createElement(Directories, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/DirectoryView/:id",
          element: /* @__PURE__ */ React.createElement(DirectoryView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/IntakeStrategies",
          element: /* @__PURE__ */ React.createElement(IntakeStrategyHome, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/IntakeStrategies/new",
          element: /* @__PURE__ */ React.createElement(IntakeStrategyNew, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/IntakeStrategies/:id",
          element: /* @__PURE__ */ React.createElement(IntakeStrategyView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/InboundAutomationView/:id",
          element: /* @__PURE__ */ React.createElement(InboundAutomationView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/InboundAutomationHome",
          element: /* @__PURE__ */ React.createElement(InboundAutomationHome, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/newIAView",
          element: /* @__PURE__ */ React.createElement(InboundAutomationNew, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/UploadTracker",
          element: /* @__PURE__ */ React.createElement(UploadTrackerView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/IntakeSettings",
          element: /* @__PURE__ */ React.createElement(IntakeSettings, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Readers",
          element: /* @__PURE__ */ React.createElement(ReadersHome, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Defaults",
          element: /* @__PURE__ */ React.createElement(DefaultHome, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Defaults/:id",
          element: /* @__PURE__ */ React.createElement(DefaultView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Readers/:id",
          element: /* @__PURE__ */ React.createElement(ReaderView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/ReaderMap/:id",
          element: /* @__PURE__ */ React.createElement(ReaderMapping, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/SystemSettings",
          element: /* @__PURE__ */ React.createElement(SystemSettings, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/AutoOCR", element: /* @__PURE__ */ React.createElement(AutoOcrHome, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/AutoOCRDocumentType/:id",
          element: /* @__PURE__ */ React.createElement(AutoOcrDocumentTypeView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/AutoOcrMapping/:id",
          element: /* @__PURE__ */ React.createElement(AutoOcrMappingView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Archive", element: /* @__PURE__ */ React.createElement(ArchiveHome, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/ArchiveView/:id",
          element: /* @__PURE__ */ React.createElement(ArchiveView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/License", element: /* @__PURE__ */ React.createElement(LicenseView, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Secret", element: /* @__PURE__ */ React.createElement(SecretHome, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/SecretView/:id",
          element: /* @__PURE__ */ React.createElement(SecretView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Credential", element: /* @__PURE__ */ React.createElement(CredentialHome, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/CredentialView/:id",
          element: /* @__PURE__ */ React.createElement(CredentialView, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/Connection",
          element: /* @__PURE__ */ React.createElement(ConnectionHome, null)
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/ConnectionView/:id",
          element: /* @__PURE__ */ React.createElement(ConnectionView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Mailbox", element: /* @__PURE__ */ React.createElement(MailboxHome, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/MailboxView/:id",
          element: /* @__PURE__ */ React.createElement(MailboxView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Companion", element: /* @__PURE__ */ React.createElement(Companion, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/CompanionView/:id",
          element: /* @__PURE__ */ React.createElement(CompanionView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Companion2", element: /* @__PURE__ */ React.createElement(CompanionPage, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/Companion2/:id", element: /* @__PURE__ */ React.createElement(CompanionPage, null) }), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/TableEditor", element: /* @__PURE__ */ React.createElement(TableEditor, null) }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/TableEditorView/:id",
          element: /* @__PURE__ */ React.createElement(TableEditorView, null)
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "/Admin/SystemAuditLogs/:id/:id2", element: /* @__PURE__ */ React.createElement(SystemAuditLogsView, null) })), loginInfo.trinDocsLicenseLevel >= 5 && /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "/Admin/AICapture",
          element: /* @__PURE__ */ React.createElement(AICapture, null)
        }
      ))
    ), alerts.length > 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "toast-container position-fixed bottom-0 end-0",
        style: { padding: "6px", paddingBottom: "20px", zIndex: "100" }
      },
      alerts.map((alert2) => /* @__PURE__ */ React.createElement(
        "div",
        {
          key: alert2.id,
          className: `toast toast-${alert2.alertType} show`,
          role: "alert",
          display: "block"
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "toast-header td-toast-header",
            style: {
              borderRadius: "8px",
              paddingRight: "15px"
            }
          },
          /* @__PURE__ */ React.createElement(
            "span",
            {
              className: "me-auto toast-message",
              style: { marginLeft: "6px" }
            },
            alert2.message
          ),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              type: "button",
              className: "btn-close",
              "data-bs-dismiss": "toast",
              "area-label": "Close",
              onClick: () => onAlertRemove(alert2.id)
            }
          )
        )
      ))
    ), /* @__PURE__ */ React.createElement("button", { id: "logOutBtn", onClick: logOutTD, style: { display: "none" } }), showAboutTrinDocs && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "td-dialogue card",
        style: { height: "220px", width: "400px" }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "About TrinDocs", /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: toggleShowAboutTrinDocs,
          className: "btn-close"
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "d-flex justify-content-center " }, /* @__PURE__ */ React.createElement("img", { style: { maxWidth: "300px" }, src: logo, className: "App-logo", alt: "logo" })), /* @__PURE__ */ React.createElement("div", { className: "d-flex justify-content-center" }, /* @__PURE__ */ React.createElement("div", { className: "App-version" }, " ", "Version ", import.meta.env.VITE_VERSION)))
    )), showAboutTrinForms && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "td-dialogue card",
        style: { height: "275px", width: "425px" }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Your Forms \u2013 Your Way!", /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: toggleShowAboutTrinForms,
          className: "btn-close"
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "d-flex justify-content-center" }, /* @__PURE__ */ React.createElement("div", { className: "App-version" }, " ", "This feature is part of our Customized Form Module (TrinForms), which is not currently enabled for your account. With TrinForms, you can create tailored forms like purchase requisitions, expense reports, capital asset requests, and more \u2013 built to fit your exact needs. To learn more or add this module to your plan, please contact us at support@trindocs.com.")))
    ))))
  );
};
export default AppRoot;
